const SUBSTATUS_TOOLTIP_MESSAGES = {
  'Agent Login Needed': 'Need agent login credentials',
  'Banking Information Needed': 'Need banking information from agents',
  'Agent Confirmation of Contract Completion Needed':
    'Waiting on agent to confirm whether they have submitted the contracting docs to the carrier',
  'Fee Approval Needed': 'Need fee approval from agent',
  'SBE Certificate Needed': 'Need SBE certificate from agent',
  'E&O Needed': 'Need E&O from agent',
  'FFM Needed': 'Need FFM from agent',
  'Completed Transfer Form Needed': 'Need completed transfer form from agent'
};

export function getSubstatusTooltip(substatus) {
  return SUBSTATUS_TOOLTIP_MESSAGES[substatus] || '';
}
